import React from "react";
import { Navigate } from "react-router-dom";
import { ScanFace } from "lucide-react";
import { useAuth, startLogin } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3">
        <ScanFace className="h-8 w-8 animate-pulse text-primary" />
        <p className="text-sm text-muted-foreground">Loading…</p>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="container flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
        <h1 className="font-display text-3xl">Sign in to continue</h1>
        <p className="max-w-sm text-muted-foreground">Create a free account to save your scans, track progress and join the leaderboard.</p>
        <button onClick={startLogin} data-testid="protected-login-btn" className="rounded-md bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground transition hover:brightness-110">
          Continue with Google
        </button>
      </div>
    );
  }

  return children;
}
